import { login, getUserDetail } from '@/api/api'
const user = {
	state: {
		avatar: '',
		users: {},
		userInfo: sessionStorage.getItem('userInfo')?JSON.parse(sessionStorage.getItem('userInfo')):{},
		token: sessionStorage.getItem('token')||'',
	},

	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token
			sessionStorage.setItem('token',token)
		},
		SET_AVATAR: (state, avatar) => {
			state.avatar = avatar
		},
		SET_USERS: (state, data) => {
			state.users = data
			state.userInfo = data
			sessionStorage.setItem('userInfo',JSON.stringify(data))
		},
		LOGOUT: (state) => {
			state.token = "";
			state.userInfo = null;
			sessionStorage.removeItem("token"); // 清除 sessionStorage
			sessionStorage.removeItem("userInfo");
			localStorage.removeItem("token"); // 如果存了 localStorage 也要清除
		}
	},

	actions: {
		// 登录
		Login({ commit }, userInfo) {
			return new Promise((resolve, reject) => {
				login(userInfo)
					.then(res => {
						if (res.code == 200) {
							const token = res.data.access_token; // 确保获取的是 token
							commit('SET_TOKEN', token);
							resolve();
						} else {
							reject(res);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		}
		,

		// 获取用户信息
		GetInfo({ commit, state }) {
			return new Promise((resolve, reject) => {
				getUserDetail().then(res => {
					console.log("=>(user.js:63) res", res.data);
					const user = res.data.enSysUserVo
					commit('SET_USERS', user)
					const avatar = (user.avatar == "" || user.avatar == null) ? require("@/assets/img/gonggao.png") : process.env.VUE_APP_BASE_API + user.avatar;
					commit('SET_AVATAR', avatar)
					resolve(res)
				}).catch(error => {
					reject(error)
				})
			})
		},
		// 退出系统
		LogOut({ commit }) {
			return new Promise((resolve) => {
				commit("LOGOUT");
				resolve();
			});
		}
	}
}

export default user
// export default {
// 	namespaced: true,
// 	state,
// 	mutations,
// 	actions,
// }
